import { on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { ItemsActions } from './items.actions';
import { MenuBaseActions } from '../base/menu-base.actions';
import { ConsumersActions } from '../consumer/consumers.actions';
import { FeatureScopeActions } from '../feature-scope/feature-scope.actions';
import { LocationSetsActions } from '../location-sets/location-sets.actions';
import { LocationSetTypesActions } from '../location-set-types/location-set-types.actions';
import * as fromItemSummary from './item-summary.reducer';
import { AsyncActions } from './items.actions';
import {ItemSummary} from '@emm/core/models/item-summary.model';
import {asyncActionState, AsyncActionState} from '@emm/core/util/async-action-state';
import {withLoadables} from '@emm/core/util/ngrx.util';

export const itemsFeatureKey = 'items';

export interface ItemsState extends EntityState<ItemSummary>, AsyncActionState {
    selectedItem: ItemSummary | null;
}

export const adapter: EntityAdapter<ItemSummary> = createEntityAdapter<ItemSummary>({
    selectId: (item: ItemSummary) => item.tag,
    sortComparer: null
});

export const initialState: ItemsState = adapter.getInitialState({
    selectedItem: null,
    ...asyncActionState.initial
});

const { loadActions, successActions, errorActions } = AsyncActions;

export const itemsReducer = withLoadables<ItemsState>({
    loadActions,
    successActions,
    errorActions
})(
    initialState,

    on(MenuBaseActions.init, state => ({
        ...initialState,
    })),

    on(
        ItemsActions.load,
        ItemsActions.loadByVenue,
        ConsumersActions.select,
        ConsumersActions.deleteSuccess,
        ConsumersActions.reloadConsumers,
        FeatureScopeActions.select,
        LocationSetTypesActions.select,
        LocationSetsActions.select,
        (state: ItemsState) =>
            adapter.removeAll({
                ...state,
                selectedItem: null,
            })
    ),

    on(ItemsActions.loadSuccess, (state: ItemsState, { items }) => adapter.setAll(items, state)),

    on(ItemsActions.select, (state: ItemsState, action) => ({
        ...state,
        selectedItem: fromItemSummary.reducer(state.selectedItem, action),
    }))

);
